import { render, staticRenderFns } from "./ViewStockMovementPage.vue?vue&type=template&id=4e17cc6b"
import script from "./ViewStockMovementPage.vue?vue&type=script&lang=js"
export * from "./ViewStockMovementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports